import React from 'react'
import { Box, DialogTitle, Typography, useTheme } from '@mui/material'
import { DialogIcon, boxStyles, dialogTitleStyles } from './styles'
import GroboticPng from '../../images/Grobotic png.png'
import GroboticLight from '../../images/Grobotic png-lightmode.png'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'

const CreateDealHeader = ({ context, cloneMode }) => {
  const theme = useTheme()
  return (
    <Box sx={boxStyles}>
      <DialogIcon src={theme.palette.mode === 'dark' ? GroboticPng : GroboticLight} />
      <Box sx={boxStyles}>
        {context && cloneMode === 'clone' ? (
          <DialogTitle
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              color: 'text.primary',
              fontWeight: 'bold',
              textAlign: 'center',
              gap: 1,
            }}
          >
            <Typography sx={{ color: 'text.subtask', fontSize: 20 }}>Clone</Typography>
            <Typography sx={{ fontSize: 20 }}>Deal</Typography>
          </DialogTitle>
        ) : context && cloneMode === 'replace' ? (
          <DialogTitle
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              color: 'text.primary',
              fontWeight: 'bold',
              textAlign: 'center',
              gap: 1,
            }}
          >
            <Typography sx={{ color: 'text.subtask', fontSize: 20 }}>Clone</Typography>
            <Typography sx={{ fontSize: 20 }}>&</Typography>
            <Typography sx={{ color: 'text.revise', fontSize: 20 }}>Replace</Typography>
            <Typography sx={{ fontSize: 20 }}>Deal</Typography>
          </DialogTitle>
        ) : (
          <DialogTitle sx={dialogTitleStyles(theme)}>{context}</DialogTitle>
        )}
        <AttachMoneyIcon
          sx={{
            color: '#fbc11e',
            width: 35,
            height: 35,
          }}
        />
      </Box>
    </Box>
  )
}

export default CreateDealHeader
